import { isValidNumber } from './isValidNumber';

/**
 * @deprecated usar edicom.locale.*
 *
 * @param {Object} params parametros de locale
 * @returns {Function}
 */
export function formatFactory({ locale = 'en', localeFormat = '', decimal = 0, currency = '' }) {
  const styles = {
      default: value => value,
      number: value => value.toLocaleString(locale, _getToLocaleOptions(decimal)),
      currency: value => value.toLocaleString(locale, _getToLocaleOptions(decimal, 'currency', currency)),
      percent: value => (value / 100).toLocaleString(locale, _getToLocaleOptions(decimal, 'percent')), // multiplica por 100 el viewValue
    },
    isNumber = localeFormat === 'number',
    isCurrency = localeFormat === 'currency' && currency.length === 3,
    isPercent = localeFormat === 'percent',
    style = !isNumber && !isCurrency && !isPercent ? 'default' : localeFormat,
    numberToString = styles[style];

  return function format(value) {
    // 04/2018 Permitimos que el valor inicial del modelo pueda ser un string válido:
    // Aun así, forzamos el Number para mostrarlo correctamente formateado a numérico (Ejemplo: '001' -> 1)
    // No podemos usar isFinity por la diferencias con Number: isFinity(''): true, Number(''): 0
    if (value === '' || !isValidNumber(value)) {
      return '';
    }
    return numberToString(Number(value));
  };
}

function _getToLocaleOptions(decimal, style, currency) {
  // Si se indican opciones al menos debe ser empty
  const options = {};
  const minDecimalLength = parseInt(decimal);

  // Sobreescribimos las opciones de decimales
  if (minDecimalLength >= 0 && minDecimalLength <= 20) {
    // Si no queremos decimales fijos hay que quitar el minimum y dejar sólo el maximum:
    options.minimumFractionDigits = minDecimalLength;
    // @odeniel - 20200129 - fuerzo el maximo de decimales al max para que
    // el formateo no trunque el value (aunque este incorrecto)
    // ver doc "maximumFractionDigits":
    // https://developer.mozilla.org/es/docs/Web/JavaScript/Referencia/Objetos_globales/Number/toLocaleString
    options.maximumFractionDigits = 20;
  }

  if (style) {
    options.style = style;
  }

  if (currency) {
    options.currency = currency;
  }

  return options;
}
